import React from 'react';
import {
  Box,
  Flex,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import { IoMenuOutline } from 'react-icons/io5';
import { SidebarResponsive } from 'components/sidebar/Sidebar';

export default function MobileMenuButton({ routes }) {
  const menuBg = useColorModeValue('white', 'navy.800');
  const shadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
    '14px 17px 40px 4px rgba(112, 144, 176, 0.06)',
  );
  
  return (
    <Box
      display={{ base: 'block', xl: 'none' }}
      position='fixed'
      top='20px'
      left='20px'
      zIndex='1000'
      bg={menuBg}
      borderRadius='12px'
      p='8px'
      boxShadow={shadow}
    >
      <SidebarResponsive routes={routes} />
    </Box>
  );
}

